import React from 'react';

import { observer } from 'mobx-react';
import { TitledInfo } from '../../../../../../shared/components/ui-components';
import { PriceInfo } from '../../../../../components/PriceInfo/PriceInfo';
import { pluralize } from '../../../../../../shared/utils/stringUtils';
import { currentSubscriptionPlanStore } from '../../../../../stores/currentSubscriptionPlanStore';
import { getIsNonPaidSubscription } from '../../../../../utils/getIsNonPaidSubscription/getIsNonPaidSubscription';

const InitialPaymentInfo = observer(() => {
  const { currentSubscriptionPlan } = currentSubscriptionPlanStore;

  if (!currentSubscriptionPlan) {
    return null;
  }

  const { subscription, explorePlan } = currentSubscriptionPlan;

  const subscriptionToShow = subscription || explorePlan;

  const isNonPaidSubscription = getIsNonPaidSubscription(
    subscriptionToShow?.subscriptionType,
  );

  return (
    <TitledInfo title="Initial payment">
      <PriceInfo
        price={subscriptionToShow?.initialPlanPrice}
        finalPrice={subscriptionToShow?.initialPlanPriceFinal}
        duration={pluralize(subscriptionToShow?.initialPlanDuration, 'month')}
        hidePrice={isNonPaidSubscription}
      />
    </TitledInfo>
  );
});

export { InitialPaymentInfo };
